import { useCallback, useState } from 'react';

/**
 * Whether the bell is swinging: it starts on each arrival — `arrivals` is
 * the bell's arrival count (`useArrivals`), the same the sound answers to —
 * and stops when the animation says it is over. An arrival during a swing
 * joins it rather than restarting it. Still on load and on a site switch.
 */
export function useBellSwing(arrivals: number): { swinging: boolean; onSwingEnd: () => void } {
  // The arrival count the last swing ended on: the bell swings while there are newer ones.
  const [endedAt, setEndedAt] = useState(0);
  const onSwingEnd = useCallback(() => setEndedAt(arrivals), [arrivals]);

  return { swinging: arrivals > endedAt, onSwingEnd };
}
